import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'

import { ROLES, ADMIN_ROLES, CAPTACION_ROLES } from '../../../core/constants'
import { TextInput, SelectInput, ThemeButton } from '../../../ui'
import { useCombos } from '../../combos'
import { useUserProfileContext } from '../contexts'

export const UserForm = () => {
  const { formatMessage } = useIntl()
  const { user, updateUser } = useUserProfileContext()
  const combos = useCombos([])
  const isCaptadorUser =
    CAPTACION_ROLES[user.rol] || user.rol === ROLES.ADMINISTRADOR_PRESCRIPTOR.KEY
  const disabled = !ADMIN_ROLES[user.rol]

  const filteredCombos = () => {
    let fCombos = { ...combos, roles: { data: combos.rol_captador_grabador.data } }
    if (isCaptadorUser) {
      const relatedCompaniesKeys = user.empresa?.cc_aa
      const availableCompanies = combos.cod_zona_zeus?.data?.filter(({ key }) =>
        relatedCompaniesKeys.includes(key)
      )
      fCombos.cod_zona_zeus = { ...combos.cod_zona_zeus, data: availableCompanies }
    }
    return fCombos
  }

  const [loading, setLoading] = useState(false)
  const [formState, setFormState] = useState(user)

  const handleChangeForm = (event) =>
    setFormState({ ...formState, [event.target.name]: event.target.value })

  const handleSubmitForm = (event) => {
    event.preventDefault()
    setLoading(true)
    let payload = { ...formState }
    for (let key in payload) {
      if (payload[key] === null) delete payload[key]
    }
    updateUser(payload)
      .then(() => setLoading(false))
      .catch(() => setLoading(false))
  }

  return (
    <form onSubmit={handleSubmitForm}>
      <Box>
        <TextInput
          fullWidth={true}
          required
          value={formState['nombre']}
          name="nombre"
          title={formatMessage({ id: 'pages.profile.user.fields.name.title' })}
          placeholder={formatMessage({ id: 'pages.profile.user.fields.name.placeholder' })}
          onChange={handleChangeForm}
        />
      </Box>

      <Box sx={{ mt: 3 }}>
        <TextInput
          fullWidth={true}
          required
          value={formState['apellidos']}
          name="apellidos"
          title={formatMessage({ id: 'pages.profile.user.fields.surname.title' })}
          placeholder={formatMessage({ id: 'pages.profile.user.fields.surname.placeholder' })}
          onChange={handleChangeForm}
        />
      </Box>

      <Box sx={{ mt: 3 }}>
        <TextInput
          fullWidth={true}
          type="email"
          required
          value={formState['email']}
          name="email"
          title={formatMessage({ id: 'pages.profile.user.fields.email.title' })}
          placeholder={formatMessage({ id: 'pages.profile.user.fields.email.placeholder' })}
          onChange={handleChangeForm}
        />
      </Box>

      <Box sx={{ mt: 3 }}>
        <TextInput
          fullWidth={true}
          inputProps={{ type: 'tel', pattern: '[6789]{1}[0-9]{8}', maxLength: 9 }}
          value={formState['telefono']}
          name="telefono"
          title={formatMessage({ id: 'pages.profile.user.fields.phone.title' })}
          placeholder={formatMessage({ id: 'pages.profile.user.fields.phone.placeholder' })}
          onChange={handleChangeForm}
        />
      </Box>

      {user.rol !== 'gremio' && user.rol !== 'comercializadora' ? (
        <>
          <Box sx={{ mt: 3 }}>
            <SelectInput
              readOnly={true}
              fullWidth={true}
              value={formState['rol']}
              values={filteredCombos().roles?.data || []}
              name="rol"
              title={formatMessage({ id: 'pages.profile.user.fields.tipo_perfil.title' })}
              placeholder="Selecciona"
            />
          </Box>
          {user.empresa?.captadora || user.rol === ROLES.ADMINISTRADOR_PRESCRIPTOR.KEY ? (
            <Box sx={{ mt: 3 }}>
              <SelectInput
                required={true}
                disabled={disabled}
                fullWidth={true}
                value={formState['cc_aa']}
                values={filteredCombos().cod_zona_zeus?.data || []}
                name="cc_aa"
                title={formatMessage({
                  id: 'pages.profile.user.fields.ambito_geografico.title',
                })}
                placeholder="Selecciona"
                onChange={handleChangeForm}
                multiple={true}
              />
            </Box>
          ) : null}
        </>
      ) : null}

      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        <ThemeButton type="submit" loading={loading}>
          {formatMessage({ id: 'pages.profile.user.button.save' })}
        </ThemeButton>
      </Box>
    </form>
  )
}
